import i18n from "i18next";
import React, { Fragment, PureComponent } from "react";
import PropTypes from "prop-types";
import UnitButtons from "../../Common/UnitsSelector/UnitButtons";
import Button from "../../Common/Button";
import Box from "../../Common/UnitsSelector/Box";

class UnitsOfMeasureButton extends PureComponent {
  static propTypes = {
    changeUnits: PropTypes.func.isRequired
  };

  state = {
    isOptionsOpen: false
  };

  handleOptionsClick = isOpen => {
    this.setState({ isOptionsOpen: typeof isOpen === typeof false ? isOpen : !this.state.isOptionsOpen });
  };

  render() {
    return (
      <Fragment>
        <div className="units-of-measure__button">
          <Button
            className="button__box"
            labelClass="button__box-label"
            label={i18n.t("box.unitsOfMeasure")}
            onClick={this.handleOptionsClick}
            icon="sliders"
          />
          <Box isOpen={this.state.isOptionsOpen} optionsClick={this.handleOptionsClick}>
            <UnitButtons changeUnits={this.props.changeUnits} />
          </Box>
        </div>
      </Fragment>
    );
  }
}

export default UnitsOfMeasureButton;



// WEBPACK FOOTER //
// ./src/components/Layout/SortedList/UnitsOfMeasureButton.js